<div class="container-fluid admin">

  <!-- HEADER -->
  <div class="d-flex justify-content-between py-4 border-bottom">
    <h2 class="title_1 m-0">Bookings
      ({{totalBookings}}
      <ng-container *ngIf="statutFC.value === 'A traiter/En attente' ||validatedAtFC.value !== null">
        - {{ LFFees | number:'':'fr-FR' }}€
      </ng-container>
      )
    </h2>


    <div>
      <div class="d-flex gap-16 align-items-center">
        <mat-form-field (keyup.enter)="doFilter()" class="search_box">
          <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="search"></mat-icon>
          <input matInput [(ngModel)]="currentSearch" placeholder="Rechercher une réservation" class="w-100"/>
        </mat-form-field>
        <button type="submit" class="btn btn-primary" role="button" (click)="doFilter()">Valider</button>
      </div>

      <div class="fst-italic minitext_2 lightGray2">
        nom,prénom,email utilisateur,<br>
        téléphone utilisateur, ref booking, ref logement,
        <br/>partenaire,ref logement LF
      </div>
    </div>

    <button role="button" class="btn btn-secondary ms-2 btn-export" (click)="exportBookings();  this.isLoading = true;">
      <span *ngIf="isLoading" class="spinner-border text-primary"></span>
      <span *ngIf="!isLoading" >Export CSV</span>
    </button>
  </div>

  <!-- filters & sort-->
  <div class="sticky-top bg-white py-4 filters d-flex align-items-center w-124">
    <div class="col-8 d-flex gap-16 flex-wrap filters">
      <mat-form-field [ngClass]="{'selected': statutFC.value}">
        <mat-label>Statut</mat-label>
        <mat-select [value]="statutFC.value" (selectionChange)="setStateFilter($event.value)">
          <mat-option class="minitext_1" *ngFor="let item of statutArray; trackBy:trackByIndex" [value]="item.value">{{item.text}}</mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="statutFC.value === 'A traiter/En attente'">
        <mat-form-field [ngClass]="{'selected': annulationFC.value}">
          <mat-label>Annulation proche</mat-label>
          <mat-select [formControl]="annulationFC">
            <mat-option class="minitext_1" value="{{null}}" (click)="hasChangedFilter = true; doFilter()">Indifférent
            </mat-option>
            <mat-option class="minitext_1" value="yes" (click)="hasChangedFilter = true; doFilter()">Oui</mat-option>
            <mat-option class="minitext_1" value="no" (click)="hasChangedFilter = true; doFilter()">Non</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field [ngClass]="{'selected': pendingFC.value}">
          <mat-label>Statut exact</mat-label>
          <mat-select [formControl]="pendingFC">
            <mat-option class="minitext_1" (click)="doFilter()" *ngFor="let item of pendingArray; trackBy:trackByIndex" [value]="item.value">{{item.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>


      <div class="customFilter position-relative" [ngClass]="{'selected': metropoleFC.value}">
        <div class="label">Métropoles</div>
        <select2 [formControl]="metropoleFC" [data]="metropoleList" resettable resetSelectedValue="null" (update)="onMetropoleChange($event)"
          displaySearchStatus="always" styleMode="noStyle" [placeholder]="null"></select2>
      </div>

      <mat-form-field [ngClass]="{'selected': contactFC.value}">
        <mat-label>Propriétaire de contact</mat-label>
        <mat-select [formControl]="contactFC">
          <mat-option class="minitext_1" (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
          <mat-option class="minitext_1" (click)="hasChangedFilter = true; doFilter()" *ngFor="let value of agentList; trackBy:trackById" [value]="value.id.toString()">
            {{value['firstname'] + ' ' + value['lastname'] }}
            <span *ngIf="validatedAtFC.value">{{' ( ' + value['sum'] + ' )'}}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field [ngClass]="{'selected': partnerFC.value}">
        <mat-label>Partenaire</mat-label>
        <mat-select [formControl]="partnerFC">
          <mat-option class="minitext_1" (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
          <mat-option class="minitext_1" (click)="hasChangedFilter = true; doFilter()" *ngFor="let value of partnerList; trackBy:trackById" [value]="value.id.toString()">{{value.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field [ngClass]="{'selected':minDurationFilter.value}">
        <mat-label>Durée de séjour</mat-label>
        <mat-select [formControl]="minDurationFilter">
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'2'">1-2 mois</mat-option>
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'6'">2-6 mois</mat-option>
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="'12'">6-12 mois</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field [ngClass]="{'selected':isStudentResidence.value}">
        <mat-label>Résidence étudiante</mat-label>
        <mat-select [formControl]="isStudentResidence">
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="true">oui</mat-option>
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="false">non</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field [ngClass]="{'selected':isInNationalityList.value}">
        <mat-label>Profil à risques</mat-label>
        <mat-select [formControl]="isInNationalityList">
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="null">Tous</mat-option>
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="true">oui</mat-option>
          <mat-option (click)="hasChangedFilter = true; doFilter()" [value]="false">non</mat-option>
        </mat-select>
      </mat-form-field>


      <button class="btn-date btn rounded-pill px-3 text-start py-0 font-14 d-sm-flex align-items-center border-grey border-1 text-nowrap"
        (click)="openCalendar(dateFilter, null)"
        [ngClass]="{'selected': dateFC.value || dateEnd.value || dateExact.value }">
        <ng-container *ngIf="!dateFC.value && !dateEnd.value && !dateExact.value else dateTemplate">Date de
          réservation
        </ng-container>
        <ng-template #dateTemplate>
          {{dateExact.value | date:'shortDate':'':'FR'}}
          <span *ngIf="dateFC.value && dateEnd.value">
            {{dateFC.value | date:'shortDate':'':'FR'}} -
            {{dateEnd.value | date:'shortDate':'':'FR'}}
          </span>
          <span *ngIf="!dateFC.value && dateEnd.value">
            {{dateEnd.value | date:'shortDate':'':'FR'}}
          </span>
        </ng-template>
      </button>
      <button class="btn-date btn rounded-pill px-3 text-start py-0 font-14 d-sm-flex align-items-center border-grey border-1 text-nowrap"
        (click)="openCalendar(createdAtFilter, null)"
        [ngClass]="{'selected': createdAtStart.value || createdAtEnd.value || createdAtExact.value }">
        <ng-container *ngIf="!createdAtStart.value && !createdAtEnd.value && !createdAtExact.value else createdAtDateTemplate">
          Date de création
        </ng-container>
        <ng-template #createdAtDateTemplate>
          {{createdAtExact.value | date:'shortDate':'':'FR'}}
          <span *ngIf="createdAtStart.value && createdAtEnd.value">
            {{createdAtStart.value | date:'shortDate':'':'FR'}} -
            {{createdAtEnd.value | date:'shortDate':'':'FR'}}
          </span>
          <span *ngIf="!createdAtStart.value && createdAtEnd.value">
            {{createdAtEnd.value | date:'shortDate':'':'FR'}}
          </span>
        </ng-template>
      </button>

      <mat-form-field [ngClass]="{'selected': validatedAtFC.value}">
        <mat-label>Date de validation</mat-label>
        <mat-select [formControl]="validatedAtFC">
          <mat-option *ngFor="let timeline of [{name:'Tous', value:null}, {name:'Aujourd\'hui', value:'today'},{name:'Hier', value:'yesterday'}, {name:'Semaine en cours', value:'week'}]"
            (click)="doFilter()"
            [value]="timeline.value">
            {{timeline.name}}
          </mat-option>
          <mat-option value="custom" (click)="openCalendar(filterWithDates, null)">
            <span *ngIf="!validatedAtValues.choice || (validatedAtValues.choice && !validatedAtValues.min) else validatedTemplate">Choisir</span>
            <ng-template #validatedTemplate>
              {{ validatedAtValues.choice === 'at' ? 'Le ' : (validatedAtValues.choice === 'before' ? 'Avant le ' : (validatedAtValues.choice === 'after' ? 'Après le ' : '')) }}
              {{ validatedAtValues.min }}
              <span *ngIf="validatedAtValues.max && validatedAtValues.choice === 'between'">
                  -
                {{ validatedAtValues.max }}
                </span>
            </ng-template>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field [ngClass]="{'selected': sortFC.value}">
        <mat-label>Tri</mat-label>
        <mat-select [formControl]="sortFC">
          <mat-option class="minitext_1" (click)="filter('')">
            Aucun tri
          </mat-option>
          <mat-option class="minitext_1" *ngFor="let sort of sortArray; trackBy:trackByIndex" (click)="filter(sort.value)" [value]="sort.text">
            {{sort.text}}
            <span class="material-icons-outlined lightGray2 font-12 v-middle" *ngIf="filterType == sort.value"
              [ngClass]="{'rotate': filterDirection == 'desc'}">arrow_upward</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <button role="button" type="reset" class="btn btn-danger" (click)="clearAll()">Clear</button>
  </div>

  <div class="d-flex align-items-start justify-content-center h-100" *ngIf="isLoading">
    <div class="spinner-border text-primary"></div>
  </div>

  <ng-container *ngIf="!isLoading">
    <!--     LISTE DES BOOKINGS   -->
    <ng-container *ngFor="let booking of displayedBookings; trackBy:trackById">
      <div class="row customHover col-12 py-3 mb-5" #page_listener>

        <div class="col-1  d-flex flex-column justify-content-center align-items-center">
          <img class="img-cover" ngSrc="{{booking['agentDisplayedAvatar']}}" alt="Avatar de l'agent" width="48" height="48"/>
          <div class="mt-2 title_3">
            {{booking.user?.agent ? booking.user.agent['firstname'] : 'Alban'}}
          </div>
        </div>
        <div class="col-2 m-0 p-0 d-flex border-end justify-content-between">
          <div class="col-10 text-start p-0">
            <div class="d-flex" [ngClass]="{'txt-yellow-happy': isRapidFilter === 'user'}">
              <ng-container *ngIf="isUserInList(booking.user.id) && (booking.status === 'Pending')">
                <lf-icon name="star" width="18px" height="18px" class="pe-2 pointer" fillColor="#FFCD1D" (click)="rapidFilter('user',booking.user['id'] ? booking.user['id'] : '')" *ngIf="isRapidFilter === 'user'"></lf-icon>
                <lf-icon name="star" width="18px" height="18px" class="pe-2 pointer" (click)="rapidFilter('user',booking.user ? booking.user['id'] : '')" *ngIf="isRapidFilter !== 'user'" [ngbPopover]="'Voir d’un coup d’œil tous les bookings d’un même utilisateur.'" [triggers]="'mouseenter:mouseleave'"></lf-icon>
              </ng-container>
              <span class="text_4 hyphens">
              {{ booking.user ? (booking.user['lastname'] + ' ' + booking.user['firstname']) : (booking['last_name'] || booking['first_name'] ? booking['last_name'] + ' ' + booking['first_name'] : 'Utilisateur inconnu') }}
            </span>
            </div>
            <div class="title_3">#{{booking['user_id']}}</div>
            <div class="copy-email minitext_1 text-ellipsis w-100" *ngIf="booking.user"
              [cdkCopyToClipboard]="(booking.user.email ? booking.user.email : '')"
              ngbPopover="Copié !"
              placement="right"
              (click)="$event.stopPropagation();">
              {{booking.user.email}}
            </div>
            <div class="minitext_1" *ngIf="booking.user">{{booking.user.phone}}</div>
            <div *ngIf="isNationalityInList(booking.user.nationality)" class="d-flex gap-2" [matTooltip]="toolTipText" [matTooltipClass]="'custom-tool-tip'">
              <lf-icon name="warning" height="13px" width="14px"></lf-icon>
              <p class="minitext_1 pt-1">client à risque</p>
              <lf-icon name="infoBlue" height="13px" width="14px"></lf-icon>
            </div>
          </div>

          <div class="d-flex flex-column gap-1">
            <a target="_blank" rel="noopener noreferrer" [ngClass]="{'disabled' : !booking.user?.crmId}" href="https://app.hubspot.com/contacts/2665222/contact/{{booking.user?.crmId}}">
              <img class="img-cover" alt="Logo hubspot" ngSrc="/assets/img/admin/picto/logo_hub.png" width="28" height="28"/>
            </a>
            <a target="_blank" rel="noopener noreferrer" [ngClass]="{'disabled' : !booking.user?.phone}" [href]="getWhatsAppLink(booking.user?.phone)">
              <img class="img-cover" alt="Logo WhatsApp" ngSrc="/assets/img/admin/picto/logo_whatsapp.png" width="28" height="28"/>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="/admin/users/{{booking['user_id']}}">
              <img class="img-cover" alt="Logo LivinFrance" ngSrc="/assets/img/admin/picto/logo1.png" width="28" height="28"/>
            </a>
          </div>
        </div>

        <div class="col-3 p-0 m-0 row">
          <div class="d-flex">
            <ng-container *ngIf="isBookingInList(booking.property.id) && (booking.status === 'Pending')">
              <lf-icon name="star" width="18px" height="18px" class="pe-2 pointer" fillColor="#FFCD1D" (click)="rapidFilter('property', booking.property['id'])" *ngIf="isRapidFilter === 'property'"></lf-icon>
              <lf-icon name="star" width="18px" height="18px" class="pe-2 pointer" (click)="rapidFilter('property', booking.property['id'])" *ngIf="isRapidFilter !== 'property'" [ngbPopover]="'Voir d’un coup d’œil tous les bookings sur une même chambre.'" [triggers]="'mouseenter:mouseleave'"></lf-icon>
            </ng-container>
            <ng-container *ngIf="isHousingIdInList(booking.property.house_id) && (booking.status === 'Pending')">
              <lf-icon name="Coloc" width="18px" height="18px" class="pe-2 pointer" fillColor="#FFCD1D" (click)="rapidFilter('house', booking.property['house_id'])" *ngIf="isRapidFilter === 'house'"></lf-icon>
              <lf-icon name="Coloc" width="18px" height="18px" class="pe-2 pointer" (click)="rapidFilter('house', booking.property['house_id'])" *ngIf="isRapidFilter !== 'house'" [ngbPopover]="'Voir d’un coup d’œil tous les bookings dans une même maison.'" [triggers]="'mouseenter:mouseleave'"></lf-icon>
            </ng-container>
            <img class="minitext_1" alt="Logo du partenaire" width="36" height="36" [src]="booking.property && booking.property['partner'] ? booking.property['partner']['logo'] : ''"/>
            <span class="text_4" [ngClass]="{'txt-yellow-happy': isRapidFilter === 'property'}">
              {{booking.property && booking.property['partner_ref'] ? booking.property['partner_ref'] : 'Nom de logement inconnu'}}
            </span>
            <a class="ms-1" target="_blank" rel="noopener noreferrer" href="{{booking.property? booking.property['link'] : ''}}">
              <svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512">
                <path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/>
              </svg>
            </a>
          </div>

          <div class="col-12 text_3">
            {{booking.property && booking.property.name ? booking.property.name : 'Propriété inconnue' }}
            <a *ngIf="booking.property" class="ms-1" target="_blank" rel="noopener noreferrer" href="{{ currentLanguage + '/accommodation/property/' + booking['property_id'] }}">
              <svg xmlns="http://www.w3.org/2000/svg" height="12" width="16" viewBox="0 0 640 512">
                <path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/>
              </svg>
            </a>
          </div>

          <div class="col-6 text_2">
            <div>#{{booking['property_id']}}</div>
            <div>Loyer : <b>{{booking['per_month'] | number:'1.0-2':'FR'}}€</b></div>
          </div>

          <div class="col-6 text_2 d-flex flex-column">
            <b>{{booking.property && booking.property['property_address'] && booking.property['property_address']['city'] ? booking.property['property_address']['city'] : 'N/A'}}</b>
            <div class="text-nowrap d-flex gap-1">
              Frais :
              <b>
                {{ (booking['reduced_reservation_fees'] && booking['reduced_reservation_fees'] !== booking['reservation_fees'] ? booking['reduced_reservation_fees'] : booking['reservation_fees']) | number: '1.0-0':'FR' }}
                €
              </b>
              <div *ngIf="booking['reduced_reservation_fees'] && toNumber(booking['reduced_reservation_fees']) !== booking['reservation_fees']"
                class="discount d-flex fw-bold">
                ({{ (booking['reservation_fees'] - booking['reduced_reservation_fees']) | number: '1.0-0':'FR'}}
                €)
                <lf-icon height="14px" name="fees" width="14px"></lf-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4 ps-4 row border-end flex-column">
          <div class="d-flex text_2 gap-1 p-0">
            Booking:
            <b>#{{booking.id}}</b>
            fait le
            <b>{{booking['created_at'] | date : 'dd/MM/yyyy'}}</b>
            <img class="pointer cstmposition ms-auto"
              (click)="getPaymentLink(booking.id)" ngSrc="/assets/img/admin/picto/{{booking['transaction_mode'] ? booking['transaction_mode'] : 'stripe'}}.png"
              height="40" width="40" alt="Icône de transaction : {{booking['transaction_mode'] ? booking['transaction_mode'] : 'stripe'}}"/>
          </div>

          <p class="d-flex justify-content-between p-0">
            <span class="text_3">
              {{booking['start_date'] | date : 'dd/MM/yyyy'}}
              -
              {{booking['end_date'] | date : 'dd/MM/yyyy'}}
              -
              <b class="title_3">{{calculateTotalLocation(booking)}} mois</b>
            </span>

            <span class="text_2" *ngIf="booking.property">
              <b>{{booking['dateDiff']}}</b>
              après la dispo
            </span>
          </p>
          <p *ngIf="booking['note']" (click)="leaveNote(noteModale,booking)" class="fst-italic customNote mt-2 px-2">{{booking['note']}}</p>
          <button *ngIf="!booking['note']" class="btn border-0 p-0 lightGray2 text-underlined w-fit-content minitext_1 mt-2" (click)="leaveNote(noteModale,booking)">
            Laisser une note
          </button>
        </div>

        <div class="col-2 position-relative row text-center p-0 ">

          <div *ngIf="booking['isBusy']" class="flex-grow-1 d-flex align-items-center justify-content-center">
            <div class="spinner-border text-primary"></div>
          </div>

          <div *ngIf="!booking['isBusy']" class="position-relative">
            <button type="button" (click)="openSideBox(true, booking)" class="btn btn-status" [ngClass]="{
              'btn-status-error': booking.status === 'Cancelled' || booking.status === 'Failed',
              'btn-status-danger': booking.status === 'Declined',
              'btn-status-accepted': booking.status === 'Accepted',
              'btn-status-pending': booking.status === 'Pending',
              'btn-status-pendingBailleur': booking.status === 'Pending' && (booking['care_status'] === null || booking['care_status'] === 'pending') && booking['pending_reason'] === 'Bailleur',
              'btn-status-pendingCustomer': booking.status === 'Pending' && (booking['care_status'] === null || booking['care_status'] === 'pending') && booking['pending_reason'] === 'Client',
              'btn-status-expired': booking.status === 'Expired'}">{{printStatus(booking.status, booking['pending_reason'])}}
              <span *ngIf="booking.status === 'Pending'" class="fw-bold">{{booking['pending_reason']}}</span>
            </button>
            <lf-icon *ngIf="booking.status === 'Pending' && (booking['care_status'] === null || booking['care_status'] === 'pending')"
              (click)="openOption(booking.id)" class="position-absolute mt-1 ms-2 customStatus" name="ellipsisVertical"
              width="18px" height="18px" fillColor="#000"></lf-icon>

          </div>
          <div class="position-absolute bg-white d-flex flex-column gap-2 updateStatusBox p-2" [ngClass]="selectedBookingId == booking.id ? 'd-block' : 'd-none'">
            <div class="title_2 d-flex border-bottom pb-1 mb-1">
              Mettre à jour
              <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="selectedBookingId = null">
                <span class="material-icons-outlined text-black">close</span>
              </button>
            </div>

            <button type="button" role="button" (click)="closeOption(booking,null)" class="btn new fw-bold">Nouveau
            </button>
            <button type="button" role="button" (click)="closeOption(booking,'Client')" class="btn customer">
              En attente -
              <b>Client</b>
            </button>
            <button type="button" role="button" (click)="closeOption(booking,'Bailleur')" class="btn bailleur">
              En attente -
              <b>Bailleur</b>
            </button>
          </div>
          <div class="minitext_1">
            <span> Update le {{booking['updated_at'] | date : 'dd/MM/yyyy'}}</span>
            <div class="p-2 lh-1 fw-bold" *ngIf="booking.status === 'Refused' || booking.status === 'Declined'">
              {{booking['refuse_reason']}}
            </div>
            <div *ngIf="(booking['HoursUntilCancellation'] > 0 && booking['transaction_mode'] == 'stripe')" class="text-danger">
              Annulation dans
              <b>{{booking['HoursUntilCancellation']}} h</b>
            </div>
            <div *ngIf="(booking['HoursUntilCancellation'] == 0 && booking['transaction_mode'] == 'stripe')" class="text-danger">
              <b>Booking remboursé</b>
            </div>
          </div>
          <div class="d-flex flex-column" *ngIf="booking['postReservationDatas'] && booking['currentStep']">
            <span class="minitext_1 txt-dark-blue">
              Etape post booking : {{ booking['currentStep'] ? booking['postReservationDatas'].indexOf(booking['currentStep']) : 0 }}
              /{{booking['postReservationDatas'].length - 1}}
            </span>
            <span class="minitext_3 fst-italic">
              ({{ booking['currentStep'] ? booking['currentStep']['title_fr'] : booking['postReservationDatas'][0]['title_fr'] }}
              )
            </span>
          </div>

        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="mt-2 text-center h-100" *ngIf="bookings && bookings.length == 0 && !isLoading">
    Aucun booking correspondant n'a été trouvé
  </div>
  <div class="mt-2 text-center h-100" *ngIf="bookings && bookings.length != 0 && !hasMoreToLoad && !isLoading || endPage">
    Tous les bookings correspondants ont été chargés
  </div>
  <mat-paginator class="sticky-bottom pb-3" [length]="totalBookings"
    [pageSize]="perPage" [disabled]="totalBookings === 0"
    [pageSizeOptions]="[5, 10, 25, 100, 1000]" [pageIndex]="pageIndex"
    (page)="paginate($event)"
    aria-label="Select page">
  </mat-paginator>

</div>

<div class="btn-top-scroll" (click)="scrollToTop()" [ngClass]="{ 'show-scroll': windowTopScrolled }">
  <button class="btn btn-lf-secondary border-2 txt-darkGray">
    <span class="material-icons-outlined">arrow_upward</span>
  </button>
</div>

<div class="btn-bottom-scroll" (click)="scrollToBottom()" [ngClass]="{ 'show-scroll': windowBottomScrolled }">
  <button class="btn btn-lf-secondary border-2 txt-darkGray">
    <span class="material-icons-outlined rotate">arrow_upward</span>
  </button>
</div>

<ng-template #filterWithDates let-modal>
  <div class="mt-3 px-4 d-flex align-items-center">
    <h5 class="title_1 m-0">Filtrer par dates</h5>
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>

  <div class="pb-4 mt-2 px-4 pt-2">
    <div class="d-flex gap-2 align-items-baseline mb-3">
      <p> Voir tous les bookings validés </p>
      <mat-form-field class="flex-grow-1">
        <mat-select [(ngModel)]="validatedAtValues.choice">
          <mat-option [value]="'before'">Avant
            le {{ validatedAtValues.min ? validatedAtValues.min : '....' }}</mat-option>
          <mat-option [value]="'at'">Le {{ validatedAtValues.min ? validatedAtValues.min : '....' }}</mat-option>
          <mat-option [value]="'between'">Entre le {{ validatedAtValues.min ? validatedAtValues.min : '....' }} et
            le {{ validatedAtValues.max ? validatedAtValues.max : '....' }}</mat-option>
          <mat-option [value]="'after'">Après
            le {{ validatedAtValues.min ? validatedAtValues.min : '....' }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <app-calendar [hideButton]="true" [isContainer]="true" [isRangeInput]="true" [isDisplayedRange]="true"
      (startDate)="setValidatedAtValues($event, 'min')" (endDate)="setValidatedAtValues($event,'max')"
      [minDate]="{ year: 2021, month: 1, day: 1 }" [maxDate]="{ year: today.getUTCFullYear(), month: today.getUTCMonth() + 1, day: today.getDate() + 1 }"></app-calendar>
    <div class="mt-3 d-flex align-items-center gap-2">
      <button role="button" class="btn btn-secondary" (click)="clearSpecificFilters('validatedAt');modal.dismiss();doFilter()">
        Clear
      </button>
      <button role="button" type="submit" class="btn btn-primary flex-grow-1" (click)="doFilter();modal.dismiss() ">
        Valider
      </button>
    </div>
  </div>
</ng-template>


<ng-template #dateFilter let-modal>
  <div class="p-5">
    <div class="mt-2 px-4 d-flex align-items-baseline">
      <h5 class="font-trueno-bold font-28 fw-bold">Filtrer les logements par date</h5>
      <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>
    <div class="flex-column justify-content-center align-items-center mt-4">
      <label for="dateTypeSelect">Choix de période:</label>
      <select class="form-select" [(ngModel)]="dateType" (change)="clearSpecificFilters('dates')" id="dateTypeSelect">
        <option value="dateExact">le</option>
        <option value="start">le ou après le</option>
        <option value="between">entre le</option>
        <option value="end">avant le</option>
      </select>
    </div>

    <div class="flex-column justify-content-center align-items-center mt-4">
      <p>Date choisie:</p>
      <span *ngIf="dateExact.value">
      {{dateExact.value | date:'shortDate':'':'FR'}}
      </span>
      <span *ngIf="dateFC.value && dateEnd.value">
          {{dateFC.value | date:'shortDate':'':'FR'}} -
        {{dateEnd.value | date:'shortDate':'':'FR'}}
      </span>
      <span *ngIf="!dateFC.value && dateEnd.value">
        {{dateEnd.value | date:'shortDate':'':'FR'}}
      </span>
      <span *ngIf="dateFC.value && !dateEnd.value">
          {{dateFC.value | date:'shortDate':'':'FR'}}
      </span>
    </div>

    <div *ngIf="dateType && dateType !== 'between'" class="d-flex justify-content-center align-items-center mt-4">
      <app-calendar #CalendarComponent (click)="$event.stopPropagation()"
        [isDisplayedRange]="true" [isUserReselect]="true"
        [isWeekendDisabled]="false" [isForcedDate]="true" (selectedDate)="setForceDate($event, dateType)"
      ></app-calendar>
    </div>
    <div *ngIf="dateType == 'between'" class="d-flex gap-2 justify-content-evenly align-items-center mt-4">
      <div class="justify-content-center">
        <p class="mb-2 d-flex justify-content-center fw-bold">date de début</p>
        <app-calendar #CalendarComponent (click)="$event.stopPropagation()"
          [isDisplayedRange]="true" [isUserReselect]="true"
          [isWeekendDisabled]="false" [isForcedDate]="true" (selectedDate)="setForceDate($event, 'start')"
        ></app-calendar>
      </div>
      <div class="justify-content-center ">
        <p class="mb-2 d-flex justify-content-center fw-bold">date de fin</p>
        <app-calendar #CalendarComponent (click)="$event.stopPropagation()"
          [isDisplayedRange]="true" [isUserReselect]="true"
          [isWeekendDisabled]="false" [isForcedDate]="true" (selectedDate)="setForceDate($event, 'end')"
        ></app-calendar>
      </div>
    </div>

    <div class="d-flex gap-16 mt-5">
      <button type="button" class="btn btn-lf-secondary" (click)="setForceDate(null, 'clear')">
        Clear
      </button>
      <button class="btn btn-lf-primary flex-grow-1" (click)="hasChangedFilter = true; doFilter(); modal.dismiss()">
        Valider
      </button>
    </div>

  </div>
</ng-template>

<ng-template #createdAtFilter let-modal>
  <div class="p-5">
    <div class="mt-2 px-4 d-flex align-items-baseline">
      <h5 class="font-trueno-bold font-28 fw-bold">Filtrer les logements par date</h5>
      <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>
    <div class="flex-column justify-content-center align-items-center mt-4">
      <label for="dateTypeSelect">Choix de période:</label>
      <select class="form-select" [(ngModel)]="dateType" (change)="clearSpecificFilters('createdAt')" id="dateTypeSelect">
        <option value="createdAtExact">le</option>
        <option value="createdAtStart">le ou après le</option>
        <option value="between">entre le</option>
        <option value="createdAtEnd">avant le</option>
      </select>
    </div>

    <div class="flex-column justify-content-center align-items-center mt-4">
      <p>Date choisie:</p>
      <span *ngIf="createdAtExact.value">
        {{createdAtExact.value | date:'shortDate':'':'FR'}}
      </span>
      <span *ngIf="createdAtStart.value && createdAtEnd.value">
            {{createdAtStart.value | date:'shortDate':'':'FR'}} -
        {{createdAtEnd.value | date:'shortDate':'':'FR'}}
      </span>
      <span *ngIf="!createdAtStart.value && createdAtEnd.value">
        {{createdAtEnd.value | date:'shortDate':'':'FR'}}
      </span>
      <span *ngIf="createdAtStart.value && !createdAtEnd.value">
          {{createdAtStart.value | date:'shortDate':'':'FR'}}
      </span>
    </div>

    <div *ngIf="dateType && dateType !== 'between'" class="d-flex justify-content-center align-items-center mt-4">
      <app-calendar #CalendarComponent (click)="$event.stopPropagation()"
        [isDisplayedRange]="true" [isUserReselect]="true"
        [maxDate]="{ year: today.getUTCFullYear(), month: today.getUTCMonth() + 1, day: today.getDate() + 1 }"
        [isWeekendDisabled]="false" [isForcedDate]="true" (selectedDate)="setForceDate($event, dateType)"
      ></app-calendar>
    </div>
    <div *ngIf="dateType == 'between'" class="d-flex gap-2 justify-content-evenly align-items-center mt-4">
      <div class="justify-content-center">
        <p class="mb-2 d-flex justify-content-center fw-bold">date de début</p>
        <app-calendar #CalendarComponent (click)="$event.stopPropagation()"
          [isDisplayedRange]="true" [isUserReselect]="true"
          [maxDate]="{ year: today.getUTCFullYear(), month: today.getUTCMonth() + 1, day: today.getDate() + 1 }"
          [isWeekendDisabled]="false" [isForcedDate]="true" (selectedDate)="setForceDate($event, 'createdAtStart')"
        ></app-calendar>
      </div>
      <div class="justify-content-center">
        <p class="mb-2 d-flex justify-content-center fw-bold">date de fin</p>
        <app-calendar #CalendarComponent (click)="$event.stopPropagation()"
          [isDisplayedRange]="true" [isUserReselect]="true"
          [maxDate]="{ year: today.getUTCFullYear(), month: today.getUTCMonth() + 1, day: today.getDate() + 1 }"
          [isWeekendDisabled]="false" [isForcedDate]="true" (selectedDate)="setForceDate($event, 'createdAtEnd')"
        ></app-calendar>
      </div>
    </div>

    <div class="d-flex gap-16 mt-5">
      <button type="button" class="btn btn-lf-secondary" (click)="setForceDate(null, 'clear')">
        Clear
      </button>
      <button class="btn btn-lf-primary flex-grow-1" (click)="hasChangedFilter = true; doFilter(); modal.dismiss()">
        Valider
      </button>
    </div>

  </div>
</ng-template>

<!------------------------------------------ MODAL ------------------------------------------>
<!-- Booking -->
<!--@todo : faire une vraie modale & clean ce qui sert plus à rien-->
<div class="position-fixed top-0 start-0 w-100 h-100 bg-dark backdropModal opacity-50" (click)="closeSideBox()" *ngIf="isModalOpen"></div>
<div class="lf-side_pop-up p-4 br-24 d-flex flex-column bg-white position-fixed overflow-auto hidden-scrollbar" *ngIf="isModalOpen" (click)="$event.stopPropagation()">
  <div class="position-relative d-flex flex-row pb-3">
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="closeSideBox()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>


  <div class="col-12 row">
    <div class="col-5 d-flex flex-row align-items-center">
      <div class="br-24 profile-image me-3 avatarPlaceholder" *ngIf="booking && booking.displayedAvatar"> {{booking.displayedAvatar}} </div>
      <img checkurl [src]="booking.user.avatar" alt="" class="br-24 profile-image me-3 img-cover" *ngIf="!booking.displayedAvatar"/>
      <div class="d-flex flex-column  font-12">
        <h5 class="font-18 fw-bold mb-0">{{booking.user ? booking.user.firstname : 'inconnu'}} {{booking.user ? booking.user.lastname : 'inconnu'}}</h5>
        <div>
          <b>#{{booking.user ? booking.user.id : 'NA'}} - </b>
          <span *ngIf="booking.user && booking.user.birthdate"> {{ calculateAge() }} ans |</span>
          <span> {{userCountry}}</span>
          <img *ngIf="booking.user && booking.user.country" class="flag-img ms-1" alt="{{userCountry}}" src="https://purecatamphetamine.github.io/country-flag-icons/3x2/{{ booking.user.country }}.svg"/>
        </div>
        <span *ngIf="booking.user && booking.user.email">{{booking.user.email}}</span>
        <span>{{booking.user ? booking.user.school.name : 'nom inconnu'}}</span>

        <span class="lightGray mt-2" *ngIf="!booking.user || !booking.user.email">email inconnu</span>
        <span class="lightGray">{{booking.user ? booking.user.phone : 'téléphone inconnu'}}</span>
        <div class="text-start">
          <div class="mt-2">
            <a target="_blank" rel="noopener noreferrer" class="me-4" [ngClass]="{'disabled' : !booking.user.crmId}" href="https://app.hubspot.com/contacts/2665222/contact/{{booking.user.crmId}}">
              <img width="28" src="/assets/img/admin/picto/logo_hub.png"/>
            </a>
            <a class="me-4" target="_blank" rel="noopener noreferrer" [ngClass]="{'disabled' : !booking.user?.phone}" [href]="getWhatsAppLink(booking.user?.phone)">
              <img width="28" src="/assets/img/admin/picto/logo_whatsapp.png"/>
            </a>
            <a target="_blank" href="/admin/users/{{booking.user_id}}">
              <img class="pointer" width="28" src="/assets/img/admin/picto/logo1.png"/>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-7">
      <!-- En-tête des Documents -->
      <div class="row mb-4">
        <h4 class="col-6">
          Documents
        </h4>
        <div class="col-6 text-end">
          <button class="btn border subtitle_1" (click)="changeDoc(docsModal)">
            <small>Gérer les documents</small>
          </button>
        </div>
      </div>

      <!-- Conteneur de la grille pour les documents -->
      <div class="row">
        <!-- Colonne de gauche (Preuve d'identité et Lettre d'admission) -->
        <div class="col-6">
          <!-- Preuve d'identité -->
          <div class="d-flex flex-row align-items-center mt-1 gap-8">
            <div class="pointer id_box br-6 d-flex justify-content-center align-items-center" (click)="goToDocument(idPhoto)" title="Voir le document dans un nouvel onglet">
              <span class="material-icons txt-yellow-happy">account_box</span>
            </div>
            <div class="d-flex flex-column w-100">
              <div class="fw-bold font-12">Document de preuve d'identité</div>
              <mat-icon (click)="goToDocument(idPhoto)" class="download-icon font-16 lightGray2 d-flex align-items-center justify-content-center pointer"
                *ngIf="idPhoto" title="Voir le document">open_in_browser
              </mat-icon>
              <span *ngIf="!idPhoto" class="fw-bold font-12 text-danger">Pas de document de preuve d'identité</span>
            </div>
          </div>

          <!-- Lettre d'admission -->
          <div class="d-flex flex-row align-items-center mt-2 gap-8">
            <div class="pointer certificate_box br-6 d-flex justify-content-center align-items-center" (click)="goToDocument(lettreAdmisssion)" title="Voir le document dans un nouvel onglet">
              <span class="material-icons text-success">school</span>
            </div>
            <div class="d-flex flex-column w-100">
              <div class="fw-bold font-12">Lettre d'admission</div>
              <mat-icon (click)="goToDocument(lettreAdmisssion)" class="download-icon font-16 lightGray2 d-flex align-items-center justify-content-center pointer"
                *ngIf="lettreAdmisssion" title="Voir le document">open_in_browser
              </mat-icon>
              <span *ngIf="!lettreAdmisssion" class="fw-bold font-12 text-danger">Pas de lettre d'admission</span>
            </div>
          </div>
          <div class="d-flex flex-row align-items-center mt-2 gap-8">
            <div class="pointer caution_box br-6 d-flex justify-content-center align-items-center" (click)="goToDocument(booking_invoice)" title="Voir le document dans un nouvel onglet">
              <span class="material-icons textCustom">paid</span>
            </div>
            <div class="d-flex flex-column w-100">
              <div class="fw-bold font-12">Facture du booking</div>
              <div class="lightGray font-10">{{booking_invoice && booking_invoice.pivot ? booking_invoice.pivot.filename : 'fichier introuvable'}}</div>
              <div class="icon_box d-flex ">
                <mat-icon (click)="goToDocument(booking_invoice)" class="download-icon font-16 lightGray2 d-flex align-items-center justify-content-center pointer"
                  *ngIf="booking_invoice" title="Voir le document">open_in_browser
                </mat-icon>
              </div>
            </div>
          </div>
        </div>

        <!-- Colonne de droite (Caution et Attestation de logement) -->
        <div class="col-6">
          <!-- Attestation de logement -->
          <div class="d-flex flex-row align-items-center mt-1  gap-8">
            <div class=" pointer caution_box br-6 d-flex justify-content-center align-items-center" (click)="goToDocument(attestationLogement)" title="Voir le document dans un nouvel onglet">
              <span class="material-icons textCustom">paid</span>
            </div>
            <div class="d-flex flex-column w-100">
              <div class="fw-bold font-12">Attestation de Logement</div>
              <div class="lightGray font-10">{{attestationLogement && attestationLogement.pivot ? attestationLogement.pivot.filename : 'fichier introuvable'}}</div>
              <mat-icon (click)="goToDocument(attestationLogement)" class="download-icon font-16 lightGray2 d-flex align-items-center justify-content-center pointer"
                *ngIf="attestationLogement" title="Voir le document">open_in_browser
              </mat-icon>
              <span *ngIf="!attestationLogement" class="fw-bold font-12 text-danger">Pas d'attestation de logement</span>
            </div>
          </div>

          <!-- Caution -->
          <div class="d-flex flex-row align-items-center gap-8 mt-2">
            <div class="pointer attest_box br-6 d-flex justify-content-center align-items-center" (click)="goToDocument(caution)" title="Voir le document dans un nouvel onglet">
              <span class="material-icons text-primary">description</span>
            </div>
            <div class="d-flex flex-column w-75">
              <div class="fw-bold font-12">Caution</div>
              <div class="lightGray d-flex flex-column font-10">
                {{caution && caution.pivot ? caution.pivot.filename : 'fichier introuvable'}}
                ({{caution?.pivot ? (caution?.pivot.type ? caution.pivot.type : (cautionType.value !== null ? cautionType.value : 'Livinfrance')) : '' }})
                <span *ngIf="caution && caution.pivot && caution.pivot.updated_at && caution.pivot.updated_at > caution.pivot.created_at " class="text-warning">
                  {{(caution.pivot.updated_at | date:'dd/MM/yyyy')}}
                </span>
              </div>
              <mat-icon (click)="goToDocument(caution)" class="download-icon font-16 lightGray2 d-flex align-items-center justify-content-center pointer"
                *ngIf="caution" title="Voir le document">open_in_browser
              </mat-icon>
              <span *ngIf="!caution" class="fw-bold font-12 text-danger">Pas de caution</span>
            </div>
            <div>
              <button class="btn border fw-bold text-nowrap px-1 font-12" (click)="openModal(uploadCaution, 'any')" title="upload caution">
                Gestion caution
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>


  </div>
  <!-- booking information -->
  <div class="infoBooking bg-grey d-flex flex-column mt-3 p-4 ">

    <!--  NOM DU PARTOS + STATUT  -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="text_1 d-flex gap-16 align-items-center">
        <img class="partner_logo aspect-ratio_1-1 img-cover" [src]="booking.property?.partner?.logo" alt="Logo partenaire"/>
        <span> Réservation:
            <span class="text-grad-red fw-bold"> #{{booking.id}}</span>
            <span class="text_2 fw-light fst-italic">
              ( le {{booking.created_at | date : 'dd/MM/yyyy'}}
              à {{booking.created_at | date : 'HH:mm'}}
              )
            </span>
          </span>
      </div>

      <div class="d-flex flex-column justify-content-center py-2 col-3 mx-0 px-0 text-center rounded-pill text-white" [ngClass]="{
        'btn-status-danger': booking.status === 'Declined' || booking.status === 'Failed',
        'bg-peach':booking.status === 'Cancelled',
        'bg-primary': booking.status === 'Accepted',
        'btn-status-pending': booking.status === 'Pending' && (booking.pending_reason !== 'Bailleur' && booking.care_status !== 'Client') ,
        'btn-status-pendingBailleur': booking.status === 'Pending' && booking.pending_reason === 'Bailleur',
        'btn-status-pendingCustomer': booking.status === 'Pending' && booking.pending_reason === 'Client',
        'modal-text-expired': booking.status === 'Expired'}">
        <p class="fw-bold">
          {{printStatus(booking.status, booking.pending_reason) }}
          <span *ngIf="booking.status === 'Pending'">{{booking.pending_reason}}</span>
        </p>
        <span class="minitext_2 lh-1" *ngIf="booking.status === 'Refused' || booking.status === 'Declined'">{{booking.refuse_reason}}</span>
      </div>

    </div>

    <div class="d-flex flex-row gap-16">
      <div class="flex-grow-1">
        <div>
          <div class="d-flex justify-content-between">
            <div class="d-flex mb-1">
              <p> {{booking.property && booking.property.partner_ref ? booking.property.partner_ref : 'Nom de logement inconnu'}}</p>
              <a class="ms-3" target="_blank" href="{{booking.property?.link}}">
                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512">
                  <path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/>
                </svg>
              </a>
            </div>
            <div class="d-flex mb-1">
              <p>{{booking.property.name}}</p>
              <a class="ms-3" target="_blank" [href]="currentLanguage + '/accommodation/property/' + booking.property_id">
                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512">
                  <path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div class="mb-1">
          <div>
            <div>
              <b>{{booking.property && booking.property.property_address.city ? booking.property.property_address.city : 'N/A'}}</b>- {{booking.property && booking.property.property_address.address_line_1 ? booking.property.property_address.address_line_1 : 'N/A'}}
              ({{booking.property.property_address.postal_code}})
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mb-1">
          <div>
            <h5 class="font-16 "> Durée: <span class="fw-bold"> {{booking.start_date | date:'shortDate':'':'FR'}}
              - {{booking.end_date | date:'shortDate':'':'FR'}}</span></h5>
            <p>Dispo:
              <span class="fw-bold">{{ booking.property.disponibility  ? (booking.property.disponibility.replace(' ', 'T') | date:'shortDate':'':'FR') : (today | date:'shortDate':'':'FR') }}</span>
              -
              <span class="fw-bold text-primary">{{booking['dateDiff']}}</span>
            </p>
            <button (click)="partnerMessage(booking)" class="btn btn-secondary btn-sm mt-3" ngbPopover="Copié !" placement="right" title="copy_message">
              message partenaire
            </button>
          </div>
          <div>
            <img *ngIf="!loadingPayment" class="pointer" (click)="getPaymentLink(booking.id)" src="/assets/img/admin/picto/{{booking.transaction_mode ? booking.transaction_mode : 'stripe'}}.png" height="50"/>
            <div *ngIf="loadingPayment" class="spinner-border text-primary" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        <hr class="border-2 m-3">
        <div>
          <div *ngIf="booking.property.contact">
            <div>
              <b>{{booking.property.contact.name}}{{booking.property.contact.lastname}}</b>
            </div>
            <div class="d-flex justify-content-between">
              <p>{{booking.property.contact.email}}
                <mat-icon *ngIf="booking.user?.email" style="vertical-align: text-top" class="copy-icon mt-2 font-10 pointer lightGrayva-sub"
                  [cdkCopyToClipboard]="(booking.property.contact.email ? booking.property.contact.email : '')" ngbPopover="Copié !" placement="right"
                  (click)="$event.stopPropagation();">filter_none
                </mat-icon>
              </p>
              <p>
                <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                  <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"/>
                </svg>
                {{booking.property.contact.phone_number}} </p>
            </div>
          </div>
          <p *ngIf="booking.note" (click)="leaveNote(noteModale,booking)" class="fst-italic customNote mt-2 px-2">{{booking.note}}</p>
          <button *ngIf="!booking.note" class="btn border-0 p-0 mediumGray fw-light text-underlined w-fit-content font-12" (click)="leaveNote(noteModale,booking)">
            Laisser une note
          </button>
        </div>

      </div>
      <div class="col-3 p-0 m-0 h-100 br-16 bgcover" style="background-image: url({{booking.cover_photo}})">
      </div>
    </div>

  </div>

  <div class="m-0 mt-3 mb-2 col-12 d-flex justify-content-between row">
    <button (click)="openModal(confirmModal, booking )" *ngIf="booking.status == 'Pending' " class="btn btn-danger col-3" title="Refuser le booking">
      Refuser
    </button>
    <button (click)="openModal(validateModal, 'validate'); isModif = true" *ngIf="booking.status !== 'Declined' && booking.status !== 'Refused' && booking.status !== 'Cancelled'" class="btn btn-lf-primary text-white col-3" title="PopUp validate pour modifier les infos (validate modal)">
      Modifier infos
    </button>

    <button (click)="openModal(validateModal, 'validate' ); isModif = false" *ngIf="booking.status == 'Pending' " class="btn btn-success col-3" title="Ouvrir la modale de validation"
    [disabled]="!idPhoto || !lettreAdmisssion || !caution || !attestationLogement">
      Accepter
    </button>
    <button (click)="endBooking()" class="btn py-2 col-3 btn-lf-primary" *ngIf="booking.status == 'Accepted' " title="Mettre fin au booking">
      Terminer le booking
    </button>
  </div>
  <div class="m-0 mt-3 mb-2 col-12 d-flex row" *ngIf="booking.status == 'Accepted'">
    <button (click)="resendInfoToPartners(booking.id)" [disabled]="booking.property?.partner?.partnership_type != 'API'" class="btn py-2 col-3 btn-success" title="Renvoyer l'email">
      <div *ngIf="isLoading" class="spinner-border text-secondary"></div>
      <p *ngIf="!isLoading">Renvoyer infos api</p>
    </button>
    <button (click)="shareBooking(booking.id)" class="btn py-2 ms-5 col-3 btn-success" title="Renvoyer l'email">
      <div *ngIf="isLoading" class="spinner-border text-secondary"></div>
      <p *ngIf="!isLoading">Renvoyer l'email</p>
    </button>
  </div>
</div>

<!-- Valider le booking -->
<ng-template #validateModal let-modal>
  <div class="p-4 modal-container hidden-scrollbar">

    <div class="d-flex flex-row border-bottom pb-4 mb-4">
      <h4 class="title_1 m-0">Confirmer les informations du client</h4>
      <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>

    <div class="d-flex flex-column gap-16">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center my-4" *ngIf="isLoading">
        <div class="spinner-border text-primary"></div>
      </div>
      <form [formGroup]="form" id="updateUserForm" class="form-row w-100 align-items-center" *ngIf="!isLoading">

        <!---------------- NOM DE FAMILLE ---------------->
        <div class="col-12 row  d-flex flex-row align-items-center">
          <div class="col-3 d-flex flex-row align-items-center">
            Nom :
          </div>
          <mat-form-field class="col-9 edit_filters mx-0 px-0" *ngIf="editingItem === 'lastname'">
            <input matInput type="text" [formControl]="form.controls.lastname">
            <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
            <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
              <span class="material-icons-outlined">close</span>
            </button>
          </mat-form-field>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'lastname'">
            <b>{{ form.value.lastname }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'lastname'" title="fermer le mode edit">
              <span class="material-icons-outlined">edit</span>
            </button>
          </div>
        </div>

        <!---------------- PRENOM ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center">Prénom :</div>
          <mat-form-field class="col-9 edit_filters mx-0 px-0" *ngIf="editingItem === 'firstname'">
            <input matInput type="text" [formControl]="form.controls.firstname">
            <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
            <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
              <span class="material-icons-outlined">close</span>
            </button>
          </mat-form-field>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'firstname'">
            <b>{{ form.value.firstname }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'firstname'">
              <span class="material-icons-outlined">edit</span></button>
          </div>
        </div>
        <!---------------- ADRESSE ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center lh-1">Adresse postale :</div>
          <div class="col-9 mx-0 px-0 edit_filters d-flex gap-8 align-items-center" *ngIf="editingItem === 'address'">
            <app-address-input class="w-100 mb-2" id="address" adressType="address" [needFormattedAddress]="true" [address2FormControl]="additionalAddressFormControl"
              [addressControl]="form.controls.address" [placeholder]="' '" (getAdditionalAddress)="setInfos($event, 'add')"
              (formattedAddress)="setInfos($event, 'formattedAddress')" (isFetchingDatas)="isFetchingDatas = $event"></app-address-input>
            <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
              <span class="material-icons-outlined">close</span>
            </button>
          </div>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'address'">
            <b>{{ displayedAddress }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'address'">
              <span class="material-icons-outlined">edit</span>
            </button>
          </div>
        </div>
        <!---------------- DATE DE NAISSANCE ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center lh-1">Date de naissance :</div>
          <div class="col-9 d-flex flex-row align-items-center mx-0 px-0" *ngIf="editingItem === 'birthdate'">
            <div class=" calendar_form d-flex">
              <app-birthdate-divided #birthdateDividedComponent [birthdate]="booking.user.birthdate" [type]="'birthdate'" (newBirthdate)="setInfos($event, 'birthdate')"></app-birthdate-divided>
              <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
                <span class="material-icons-outlined">close</span>
              </button>
            </div>
            <div class="text-danger font-12" *ngIf="!isBirthdayCorrect || (isFormSubmitted && form.controls.birthdate.invalid)">{{ 'COMMON.BIRTHDATE_FORMAT.INVALIDE' | translate }}</div>
          </div>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'birthdate'">
            <b>{{ form.value.birthdate | date:'longDate':'':'FR' }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'birthdate'">
              <span class="material-icons-outlined">edit</span></button>
          </div>
        </div>
        <!---------------- LIEU DE NAISSANCE ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center lh-1">Lieu de naissance :</div>
          <div class="col-9 mx-0 px-0 d-flex flex-row align-items-center" *ngIf="editingItem === 'birthplace'">
            <app-city-input class="mediumGray w-100" [wantedField]="'birthplace'" [user]="booking.user" [floatLabel]="'auto'"
              [cityControl]="form.controls.birthplace" (onChange)="setInfos($event, 'city')"></app-city-input>
            <button class="btn border-0 mt-3 ms-auto" (click)="cancelChanges()" title="fermer le mode edit">
              <span class="material-icons-outlined">close</span>
            </button>
          </div>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'birthplace'">
            <b>{{ form.value.birthplace + ', ' + birthCountry }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'birthplace'">
              <span class="material-icons-outlined">edit</span></button>
          </div>
        </div>

        <!---------------- EMAIL ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center">Email :</div>
          <div class="col-9 d-flex flex-row align-items-center mx-0 px-0 edit_filters" *ngIf="editingItem === 'email'">
            <mat-form-field class=" position-relative w-100">
              <input type="email" matInput [formControl]="form.controls.email" email="true">
              <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
              <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
                <span class="material-icons-outlined">close</span>
              </button>
            </mat-form-field>
            <div *ngIf="isFormSubmitted && emailError" class="text-danger font-12">
              <b>{{ "PROFILE.EMAIL_ALREADY_TAKEN" | translate }}</b>
            </div>
          </div>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'email'">
            <b>{{ form.value.email }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'email'"><span class="material-icons-outlined">edit</span>
            </button>
          </div>
        </div>

        <!---------------- PHONE ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center lh-1">Téléphone :</div>
          <div class="col-9 d-flex flex-row align-items-center mx-0 px-0" *ngIf="editingItem === 'phone'">
            <mat-form-field class="w-100 position-relative edit_filters">
              <input matInput type="text" [formControl]="form.controls.phone"/>
              <div *ngIf="isFormSubmitted && form.controls.phone.errors" class="invalid-feedback d-block">
                <div *ngIf="form.controls.phone.errors.required"> {{ "COMMON.IS_REQUIRED" | translate }} </div>
                <div *ngIf="form.controls.phone.errors.validatePhoneNumber"> {{ "COMMON.IS_INVALID" | translate }} </div>
              </div>
              <button type="button" class="btn border-0 mt-1" (click)="cancelChanges()" title="fermer le mode edit">
                <span class="material-icons-outlined">close</span>
              </button>
            </mat-form-field>
          </div>

          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'phone'">
            <b>{{ form.value.phone }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'phone'"><span class="material-icons-outlined">edit</span>
            </button>
          </div>
        </div>

        <!---------------- Arrivée ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center">Arrivée (estimée) :</div>
          <mat-form-field class="col-9 mx-0 px-0 edit_filters" *ngIf="editingItem === 'start_date'">
            <input matInput type="text" [formControl]="form.controls.start_date">
            <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
            <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
              <span class="material-icons-outlined">close</span>
            </button>
          </mat-form-field>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'start_date'">
            <b>{{ form.value.start_date }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'start_date'">
              <span class="material-icons-outlined">edit</span></button>
          </div>
        </div>

        <!---------------- Départ ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center">Départ (estimé) :</div>
          <mat-form-field class="col-9 mx-0 px-0 edit_filters" *ngIf="editingItem === 'end_date'">
            <input matInput type="text" [formControl]="form.controls.end_date">
            <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
            <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
              <span class="material-icons-outlined">close</span>
            </button>
          </mat-form-field>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'end_date'">
            <b>{{ form.value.end_date }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'end_date'">
              <span class="material-icons-outlined">edit</span>
            </button>
          </div>
        </div>

        <!---------------- ID logement ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center">Id logement LivinFrance:</div>
          <mat-form-field class="col-9 mx-0 px-0 edit_filters" *ngIf="editingItem === 'property_id'">
            <input matInput type="number" [formControl]="form.controls.property_id">
            <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
            <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
              <span class="material-icons-outlined">close</span>
            </button>
          </mat-form-field>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'property_id'">
            <b>{{ form.value.property_id }}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'property_id'">
              <span class="material-icons-outlined">edit</span></button>
          </div>
        </div>

        <!---------------- Agent ---------------->
        <div class="col-12 row">
          <div class="col-3 d-flex flex-row align-items-center">Agent :</div>
          <mat-form-field class="col-9  mx-0 px-0 edit_filters" *ngIf="editingItem === 'agent'">
            <mat-select matInput [formControl]="form.controls.agent">
              <mat-option *ngFor="let agent of agentList" [value]="agent">{{agent.firstname}}</mat-option>
            </mat-select>
            <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
            <button class="btn border-0" (click)="cancelChanges()" title="fermer le mode edit">
              <span class="material-icons-outlined">close</span>
            </button>
          </mat-form-field>
          <div class="col-9 d-flex flex-row align-items-center m-0 p-0" *ngIf="editingItem !== 'agent'">
            <b>{{ form.value.agent.firstname}}</b>
            <button class="btn ms-auto border-0" (click)="editingItem = 'agent'"><span class="material-icons-outlined">edit</span>
            </button>
          </div>
        </div>

      </form>

      <div class="w-100 d-flex gap-8 align-items-center" *ngIf="!isUpdatingBooking">
        <button (click)="modal.dismiss()" class="btn btn-lf-secondary flex-grow-1" title="Fermer la modale">
          Annuler
        </button>
        <button (click)="updateUser()" class="btn btn-primary flex-grow-1" title="Accepter le booking" [disabled]="isLoadingCaution">
          Sauvegarder
        </button>
        <button *ngIf="booking && isModif == false" (click)="generateCaution(booking.user.id, booking.id)" [disabled]="isLoadingCaution"
          class="btn btn-primary flex-grow-1" title="Mettre à jour la caution">
          Mettre à jour la caution
        </button>
        <button *ngIf="booking && booking.status == 'Pending' && isModif == false" (click)="sendBooking()" [disabled]="isLoadingCaution"
          class="btn btn-primary flex-grow-1 py-2" title="Accepter le booking">
          Accepter
        </button>
      </div>
      <div *ngIf="isUpdatingBooking">
        <button class="btn btn-primary" type="button" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="sr-only">Mise à jour du booking en cours...</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- leave a note -->
<ng-template #noteModale let-modal>
  <div class="mt-3 px-4 d-flex align-items-center">
    <h5 class="title_1 m-0">Laisser une note</h5>
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>

  <form [formGroup]="formNote" (ngSubmit)="sendNote(booking)" class="pb-4 mt-2 px-4 pt-2">
    <textarea name="content" id="content" cols="30" rows="4" class="form-control" formControlName="content"></textarea>

    <button class="btn btn-primary mt-4 w-100" (click)="sendNote(booking)" [disabled]="isSending">
      <span *ngIf="isSending" class="spinner-border spinner-border-sm v-middle"></span>
      Sauvegarder la note
    </button>
  </form>
</ng-template>

<!-- upload de caution -->
<ng-template #uploadCaution let-modal>
  <div *ngIf="!isLoadingCaution" class="p-4 modal-container">
    <div class="d-flex align-items-center justify-content-center mb-3">
      <h5 class="title_1 m-0">Uploader une caution</h5>
      <button type="button" class="btn btn-close lightGray2 ms-auto" aria-label="Close" (click)="modal.dismiss()">
      </button>
    </div>
    <div class="justify-content-center border-bottom pb-4 mb-4">
      <mat-form-field>
        <mat-label>Type de caution</mat-label>
        <mat-select [formControl]="cautionType">
          <mat-option  [value]="'Visale'">Visale</mat-option>
          <mat-option  [value]="'Garantme'">Garantme</mat-option>
          <mat-option  [value]="'Smartgarant'">Smartgarant</mat-option>
          <mat-option  [value]="'Autre'">Autre</mat-option>
        </mat-select>
      </mat-form-field>
      <app-upload-file *ngIf="cautionType.value !== null" (onDelete)="onDelete($event)" (onUpload)="onUpload($event)" [userId]="booking.user.id" [documentType]="'CTNMNT'"
        [mode]="'single'" class="w-75"></app-upload-file>
    </div>

    <div class="d-flex justify-content-center flex-column">
      <h5 class="title_1 mb-3">Génerer une caution</h5>
      <button class="btn btn-primary" (click)="generateCaution(booking.user.id, booking.id)" [disabled]="isLoadingCaution">
        Génerer
      </button>
    </div>
  </div>

  <div class="d-flex flex-column justify-content-center align-items-center mt-5 mb-5 pb-5 pt-5 gap-2" *ngIf="isLoadingCaution">
    <span>{{ documentUploadStatus }}</span>
    <span class="spinner-border d-flex text-primary"></span>
  </div>

</ng-template>

<!-- liste des documents -->
<ng-template #docsModal let-modal>
  <div class="modal-container hidden-scrollbar p-4">
    <div class="d-flex align-items-center border-bottom pb-4 mb-4">
      <h5 class="title_1 m-0">Modifier les documents</h5>
      <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>
    <div class="d-flex flex-row flex-wrap gap-16">
      <app-doc-management class="w-50" *ngFor="let doc of booking.user.documents" [reload]="false" [doc]="doc['pivot']"></app-doc-management>
    </div>
  </div>
</ng-template>

<!-- refuser le booking -->
<ng-template #confirmModal let-modal>
  <div class="modale-container p-4">
    <div class="d-flex flex-row align-items-baseline border-bottom pb-4 mb-4">
      <h4 class="title_1 m-0">Refuser le booking ?</h4>
      <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
        <span class="material-icons-outlined text-black">close</span>
      </button>
    </div>

    <mat-radio-group [(ngModel)]="selectedReason" class="d-flex gap-16 flex-column">
      <mat-radio-button *ngFor="let reason of refusalArray; trackBy:trackByIndex"
        [ngClass]="{'fw-bold' : selectedReason === reason}" class="text_2" value="{{reason}}">
        {{ reason }}
      </mat-radio-button>
    </mat-radio-group>

    <div class="d-flex justify-content-center gap-24 mt-4">
      <div *ngIf="isLoading" class="spinner-border text-primary me-5"></div>
      <button *ngIf="!isLoading" class="btn btn-success" (click)="refuseBooking(booking.user.id, booking.id, selectedReason)">
        Confirmer
      </button>
      <button class="btn btn-danger" (click)="modal.dismiss()">Annuler</button>
    </div>
  </div>

</ng-template>
